// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

// Helper function to get token - avoids circular dependency
const getAuthToken = () => {
    // Try to get from localStorage first (fallback)
    return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
};

export async function fetchProfile() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/profile`;
    const response = await fetch(url, {
        method: 'GET',
        headers,
    });

    // Check for 401 status
    checkResponseStatus(response);

    let data;
    try {
        data = await response.json();
    } catch (e) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error: ${response.status} ${response.statusText}`);
    }

    if (!response.ok) {
        const errorMessage = data?.message || `Server error: ${response.status} ${response.statusText}`;
        throw new Error(errorMessage);
    }
    return data;
}

export async function updateProfile(profileData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();

    // Create FormData instead of JSON
    const formData = new FormData();

    // Append all profile data to FormData
    if (profileData.name) formData.append('name', profileData.name);
    if (profileData.phone) formData.append('phone', profileData.phone);
    if (profileData.phone_code) formData.append('phone_code', profileData.phone_code);
    if (profileData.address) formData.append('address', profileData.address);
    if (profileData.file) formData.append('profile', profileData.file);

    const headers = {};
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }
    // Note: Don't set Content-Type for FormData, browser will set it automatically with boundary

    const url = `${API_BASE_URL}api/v1/dashboard/profile/update`;
    const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: formData
    });

    // Check for 401 status
    checkResponseStatus(response);

    let data;
    try {
        data = await response.json();
    } catch (e) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error: ${response.status} ${response.statusText}`);
    }

    if (!response.ok) {
        const errorMessage = data?.message || `Server error: ${response.status} ${response.statusText}`;
        throw new Error(errorMessage);
    }
    return data;
}

export async function changePassword(passwordData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    const url = `${API_BASE_URL}api/v1/dashboard/profile/change-password`;
    const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({
            old_password: passwordData.oldPassword,
            new_password: passwordData.newPassword,
            confirm_password: passwordData.confirmPassword
        })
    });

    // Check for 401 status
    checkResponseStatus(response);

    let data;
    try {
        data = await response.json();
    } catch (e) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error: ${response.status} ${response.statusText}`);
    }

    if (!response.ok) {
        const errorMessage = data?.message || `Server error: ${response.status} ${response.statusText}`;
        throw new Error(errorMessage);
    }
    return data;
}
